<template>
    <div class="examresults">
        <div class="exam-results-box">
            <div class="exam-results-top">
                <div :style="{ height: statusBarHeight + 'px', background: '#fff' }"></div>
                <van-nav-bar title="交卷完成" left-arrow @click-left="goBack" />
            </div>
            <div v-if="isfacedialog && resultsobj">
                <facedialog
                    :trainItemExamId="trainItemExamId"
                    :businessType="businessType"
                    :examId="resultsobj.examId"
                    :businessId="businessId"
                    @close="close"
                ></facedialog>
            </div>
            <div class="exam-results-bgbox">
                <div class="exam-results-bg">
                    <div class="exam-results-content1">
                        <!--交卷完成列表-->
                        <div :class="setExamBg('bg')" class="exam-results-circle">
                            <p
                                v-if="resultsobj.scoreAuth"
                                :class="resultsobj.isPass === 0 ? 'nopasstext' : 'passtext'"
                                class="examscore"
                            >
                                {{ resultsobj.score }}
                                <span>分</span>
                            </p>
                            <div v-if="examtext === '1'">
                                <p class="examtext examtextcolor1">您的考试已提交</p>
                                <p class="examtext examtextcolor11">感谢参与作答～</p>
                            </div>
                            <p v-else :class="setExamBg('text')" class="examtext">{{ examtext }}</p>
                            <div class="examscoreinfo-div">
                                <p v-if="resultsobj.scoreAuth" class="examscoreinfo">
                                    <span>及格线{{ resultsobj.passingScore }}</span>
                                    <span>总分{{ resultsobj.totalScore }}</span>
                                </p>
                            </div>
                        </div>
                        <!-- 违规 -->
                        <div class="exam-results-weigui" v-show="resultsobj.cheat == 1">
                            <span class="font">违规：</span>
                            <span class="font color2">{{ resultsobj.remark }}</span>
                        </div>
                        <!-- 不是组合题和paperType不为4才展示 -->
                        <div class="exam-results-ulbox" v-if="resultsobj.paperType!=4&&!resultsobj.combination">
                            <ul class="hasScore" v-if="resultsobj.scoreAuth">
                                <li>
                                    <svg-icon icon-class="exam-right-icon" class-name="hasScore-icon"></svg-icon>
                                    <p>{{ resultsobj.rightCount }}</p>
                                    <span>正确</span>
                                </li>
                                <li>
                                    <svg-icon icon-class="exam-error-icon" class-name="hasScore-icon"></svg-icon>
                                    <p>{{ resultsobj.errorCount }}</p>
                                    <span>错误</span>
                                </li>
                                <li>
                                    <svg-icon icon-class="exam-empty-icon" class-name="hasScore-icon"></svg-icon>
                                    <p>{{ resultsobj.emptyCount }}</p>
                                    <span>未答</span>
                                </li>
                                <li>
                                    <svg-icon icon-class="exam-total-icon" class-name="hasScore-icon"></svg-icon>
                                    <p>{{ resultsobj.totalCount }}</p>
                                    <span>总题数</span>
                                </li>
                            </ul>
                            <ul class="noScore" v-if="!resultsobj.scoreAuth && !resultsobj.isValid">
                                <li>
                                    <img src="../../../assets/images/exam/numall.png" alt="" />
                                    <div class="numalltext">
                                        <p>{{ resultsobj.totalCount }}</p>
                                        <span>总题数</span>
                                    </div>
                                </li>
                                <li>
                                    <img src="../../../assets/images/exam/scoreall.png" alt="" />
                                    <div class="numalltext">
                                        <p>{{ resultsobj.totalScore }}</p>
                                        <span>总分数</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <!--公共引入部分-->
                        <div
                            :class="
                                !resultsobj.isValid || (resultsobj.isValid && !resultsobj.questionAuth) ? 'bd' : 'br'
                            "
                            class="exam-results-title"
                        >
                            <p class="title">
                                考试名称：
                                <span>{{ resultsobj.examName }}</span>
                            </p>
                            <p class="examtime">
                                考试时间：
                                <span>{{ resultsobj.examStartTime }}</span>
                            </p>
                            <p>
                                考试用时：
                                <span>{{ resultsobj.useDuration }}</span>
                            </p>
                        </div>
                        <div
                            v-if="!resultsobj.isValid"
                            :class="!resultsobj.questionAuth ? 'bd' : 'br'"
                            class="exam-results-title"
                        >
                            <p class="title">
                                异常记录：
                                <span>{{ resultsobj.exceptionTime }}</span>
                            </p>
                            <p>
                                异常原因：
                                <span class="validcause">{{ invalidTypetext }}</span>
                            </p>
                        </div>
                        <div v-if="resultsobj.questionAuth" class="exam-msg-btn" @click="examInfoUrl">
                            查看试卷详情
                            <img src="../../../assets/images/exam/right@2x.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <!--考试查看列表-->
            <div v-if="showbtn" class="exam-results-fotter">
                <button
                    :class="resultsobj.yetExamCount === resultsobj.examCount ? 'btn-lowheight' : 'btn-heightlight'"
                    @click="exampath"
                >
                    {{ btntext }}
                </button>
                <p v-if="resultsobj.examCount">
                    （已考{{ resultsobj.yetExamCount }}次/共{{ resultsobj.examCount }}次）
                </p>
                <div :style="{ height: bottomSafeHeight + 'px' }"></div>
            </div>
        </div>
    </div>
</template>

<script>
import facedialog from '../../../layout/facedialog.vue'
export default {
    name: 'examresults',
    components: {
        facedialog
    },
    data() {
        return {
            btntext: '',
            resultsobj: {},
            resultsId: '',
            trainItemExamId: '',
            businessType: null,
            businessId: null,
            isfacedialog: false,
            examId: null,
            invalidTypetext: '',
            stopClickLogin: false,
            examtext: '',
            showbtn: false,
            statusBarHeight: 0,
            bottomSafeHeight: 0
        }
    },
    created() {
        this.showbtn = this.$route.query.showbtn ? false : true
        this.resultsId = this.$route.query.id || this.$route.query.userPaperId
        this.trainItemExamId = Number(this.$route.query.trainItemExamId)
        this.businessType = Number(this.$route.query.businessType)
        this.businessId = Number(this.$route.query.businessId)
        this.findUserPaperSurface()
    },
    mounted() {
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL)
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener('popstate', this.backChange, false) //false阻止默认事件
        }
        if (localStorage.getItem('type') == 'iOS') {
            this.statusBarHeight = localStorage.getItem('statusBarHeight')
            this.bottomSafeHeight = localStorage.getItem('bottomSafeHeight')
        }
    },
    destroyed() {
        window.removeEventListener('popstate', this.backChange, false) //false阻止默认事件
    },
    methods: {
        goBack() {
            this.$router.push({
                name: 'examlistDetails',
                query: {
                    trainId: this.$route.query.businessId,
                    trainItemExamId:
                        (this.resultsobj && this.resultsobj.examId) ||
                        this.$route.query.trainItemExamId ||
                        this.$route.query.examId,
                    type: this.$route.query.businessType,
                    backType: this.$route.query.backType,
                    backPath: this.$route.query.backPath,
                    goodsId: this.$route.query.goodsId,
                    goodsKind: this.$route.query.goodsKind
                }
            })
        },
        getExamText() {
            if (this.resultsobj.scoreAuth && this.resultsobj.isPass) {
                this.examtext = '恭喜您！考试及格'
            } else if (this.resultsobj.scoreAuth && !this.resultsobj.isPass) {
                this.examtext = '不及格，再接再厉！'
            } else if (!this.resultsobj.scoreAuth && !this.resultsobj.isValid) {
                this.examtext = '检测到您有异常行为！'
            } else if (!this.resultsobj.scoreAuth && this.resultsobj.isValid) {
                this.examtext = '1'
            }
        },
        setExamBg(val) {
            if (this.resultsobj.scoreAuth && this.resultsobj.isPass) {
                // 可以查看成绩，并且成绩及格
                return val === 'bg' ? 'exampassbg circle' : 'examtextcolor4'
            } else if (this.resultsobj.scoreAuth && !this.resultsobj.isPass) {
                // 可以查看成绩, 成绩不及格
                return val === 'bg' ? 'examnopassbg circle' : 'examtextcolor2'
            } else if (!this.resultsobj.scoreAuth && !this.resultsobj.isValid) {
                // 不可查看成绩， 有异常
                return val === 'bg' ? 'examvalidno circlevalid' : 'examtextcolor3'
            } else if (!this.resultsobj.scoreAuth && this.resultsobj.isValid) {
                // 不可查看成绩， 无异常
                return val === 'bg' ? 'examvalid circlevalid' : 'examtextcolor1'
            }
        },
        backChange() {
            this.$router.push({
                path: '/examlistDetails',
                query: {
                    trainId: this.$route.query.businessId,
                    contentId: this.resultsobj.examId,
                    type: this.$route.query.businessType,
                    backType: this.$route.query.backType,
                    backPath: this.$route.query.backPath
                }
            })
        },
        examInfoUrl() {
            this.$router.push({
                path: '/examTaking',
                query: {
                    userPaperId: this.resultsId,
                    examId: this.resultsobj.examId,
                    businessType: this.businessType,
                    businessId: this.businessId,
                    trainItemExamId: this.trainItemExamId,
                    type: this.$route.query.type === 'historical' ? 'historical' : 'examInfo',
                    backType: this.$route.query.backType,
                    showbtn: this.$route.query.showbtn,
                    backPath: this.$route.query.backPath,
                    goodsId: this.$route.query.goodsId,
                    goodsKind: this.$route.query.goodsKind
                }
            })
        },
        close(val) {
            this.isfacedialog = val
        },
        isDuringDate(beginDateStr, endDateStr) {
            var curDate = new Date(),
                beginDate = new Date(beginDateStr.replace(/-/g, '/')),
                endDate = new Date(endDateStr.replace(/-/g, '/'))
            if (curDate >= beginDate && curDate <= endDate) {
                return true
            }
            return false
        },
        exampath() {
            if (this.stopClickLogin) {
                return false
            }
            this.stopClickLogin = true
            setTimeout(() => {
                this.stopClickLogin = false
            }, 5000)
            if (this.resultsobj.yetExamCount !== this.resultsobj.examCount) {
                let istime = this.resultsobj.isLimitTime
                    ? this.isDuringDate(this.resultsobj.trainExamStartTime, this.resultsobj.trainExamEndTime)
                    : true
                if (istime) {
                    let nowTime = new Date().getTime()
                    let startTime = new Date(this.resultsobj.trainExamStartTime).getTime()
                    let lateTime = this.resultsobj.allowLateDuration * 60 * 1000
                    if (this.resultsobj.allowLateDuration > 0 && nowTime > startTime + lateTime) {
                        this.$dialog.alert({
                            title: '提示',
                            message: '您已超过最迟开考时间'
                        })
                    } else if (this.resultsobj.isFaceRecogBeforeExam == 0) {
                        this.$router.push({
                            path: '/reading',
                            query: {
                                userPaperId: this.resultsId,
                                examId: this.resultsobj.examId,
                                businessType: this.businessType,
                                businessId: this.businessId,
                                trainItemExamId: this.trainItemExamId,
                                backType: this.$route.query.backType,
                                backPath: this.$route.query.backPath
                            }
                        })
                    } else {
                        this.isfacedialog = true
                    }
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '不在考试范围内'
                    })
                }
            }
        },
        findUserPaperSurface() {
            let params = {
                userPaperId: this.resultsId
            }
            this.$api.exam.findUserPaperSurface(params).then(async data => {
                data.data.useDuration = this.timeFormatter(data.data.useDuration)
                this.resultsobj = data.data
                if (this.showbtn) {
                    this.$nextTick(() => {
                        let main = document.querySelector('.exam-results-content1')
                        const h = window.innerHeight * 0.13
                        main.style.paddingBottom = h + 'px'
                    })
                }
                localStorage.setItem('isFaceRecogCommitExam', this.resultsobj.isFaceRecogCommitExam)
                localStorage.setItem('isFaceRecogDuringExam', this.resultsobj.isFaceRecogDuringExam)
                this.btntext = this.resultsobj.yetExamCount === this.resultsobj.examCount ? '考试机会已用完' : '重考'
                this.getExamText()
                switch (this.resultsobj.invalidType) {
                    case 1:
                        this.invalidTypetext = '人脸识别失败'
                        break
                    case 2:
                        this.invalidTypetext = `考试过程中切换屏幕离开考场超过${this.resultsobj.switchScreenNum}次`
                        break
                    case 3:
                        this.invalidTypetext = '多人出现超过次数限制'
                        break
                    case 4:
                        this.invalidTypetext = '不是本人超过次数限制'
                        break
                    case 5:
                        this.invalidTypetext = '检测不到人超过次数限制'
                        break
                    case 7:
                        this.invalidTypetext = '管理员强制交卷'
                        break
                    case 9:
                        this.invalidTypetext = '系统交卷'
                        break
                    default:
                        break
                }
            })
        },
        timeFormatter(time) {
            const hours = Math.floor(time / 60 / 60)
            const minutes = Math.floor((time / 60) % 60)
            const seconds = Math.floor(time % 60)
            var hours1 = hours < 10 ? '0' + hours : hours
            var minutes1 = minutes < 10 ? '0' + minutes : minutes
            var seconds1 = seconds < 10 ? '0' + seconds : seconds
            return hours1 + '时' + minutes1 + '分' + seconds1 + '秒'
        }
    }
}
</script>
<style>
.exam-results-box .van-nav-bar__title {
    color: #31333a !important;
}
.exam-results-box .van-nav-bar .van-icon {
    color: #31333a !important;
}
.exam-results-box .van-hairline--bottom::after {
    border-bottom-width: 0px;
}
</style>
<style lang="less" scoped>
@import '../asset/css/examresults.less';
</style>
